import { useQuery, UseQueryResult } from "@tanstack/react-query"
import { Entry } from "contentful"
// TypeCalendlyLinkSkeleton is the TimeTap link type, auto-generated from Contentful
import { TypeCalendlyLinkSkeleton, TypeTileSkeleton } from "#/types/contentful"
import {
  getTimeTapLinkByReasonIdAndLocationId,
  getParentTileEntries,
  getTileEntries
} from "#/lib/contentful/contentfulClient"
import { mapContentToTile, Tile } from "#/components/talk-to-carrot/util/utils"
import { EntryWithoutUnresolvableLinks } from "#/utils/ContentTypes"
import ResponseError from "#/types/responseError"

const QUERY_KEY = ["parent-tile-entry"]

export const useParentContentfulTileEntry = (currentEntryId: string, shouldFetch: boolean) => {
  return useQuery<Entry<TypeTileSkeleton, "WITHOUT_UNRESOLVABLE_LINKS", string>[]>(
    [QUERY_KEY],
    () => getParentTileEntries(currentEntryId),
    {
      enabled: !!currentEntryId && shouldFetch
    }
  )
}

const TILE_ENTRIES_QUERY_KEY = ["contentful-tiles"]

export const useTileEntriesFromContentful = (tileEntryIds: string[]) => {
  return useQuery<Tile[]>([TILE_ENTRIES_QUERY_KEY, tileEntryIds], async () => {
    const entries = await getTileEntries(tileEntryIds)
    return entries
      .map((entry) => {
        return mapContentToTile(entry as EntryWithoutUnresolvableLinks<TypeTileSkeleton>)
      })
      .filter(Boolean)
  })
}

const TIMETAP_LINK_QUERY_KEY = ["timeTapLink"]

export const useTimeTapLink = (
  reasonId: number,
  locationId: number
): UseQueryResult<EntryWithoutUnresolvableLinks<TypeCalendlyLinkSkeleton>, ResponseError> => {
  return useQuery<EntryWithoutUnresolvableLinks<TypeCalendlyLinkSkeleton>, ResponseError>(
    TIMETAP_LINK_QUERY_KEY,
    async () => {
      return getTimeTapLinkByReasonIdAndLocationId(reasonId, locationId)
    },
    {
      refetchOnWindowFocus: false
    }
  )
}
